import React from 'react';
import { connect } from 'react-redux';
import {
    Modal,
    Button,
    Row,
    Col,
    Checkbox,
    DropdownButton,
    MenuItem,
    FormControl,
} from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import map from 'lodash/map';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import Comments from '../../../../../components/Comments/Comments';
import { validateFields } from '../../../../../shared/utils/handleBlowoutValidations';
import SmallLoader from '../../../../../components/SmallLoader/index';
import {
    createPullForwardRecoveryAction,
    createSlideRecoveryAction,
    getIsPending,
    getErrorMessage,
    clearErrorMessage,
    getError,
} from '../../../recoveryActionsDuck';
import { get, post } from '../../../../../shared/http/request';
import { handleApiError } from '../../../../../shared/http/error';
import { bindActionCreators } from 'redux';
import { formatRun, formatStopLocation } from '../../../../../shared/utils/run';

class SlidePullModal extends React.Component {
    state = {
        comment: '',
        commonRuns: [],
        dueDate: '',
        errors: {},
        fetchingCommonRuns: false,
        fetchingToRuns: false,
        fetchingToRunStops: false,
        fromRunId: '',
        newLoadStopId: '',
        newUnloadStopId: '',
        tapChecked: false,
        tapDate: '',
        tapDueDate: '',
        tapNumber: '',
        toRunId: '',
        toRuns: [],
        toRunStops: [],
    };

    componentDidMount() {
        this.getFromRuns();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isPending && !nextProps.isRejected) {
            this.props.onClose();
        }
    }

    componentWillUnmount() {
        this.props.clearErrorMessage();
    }

    getFromRuns = () => {
        this.setState({ fetchingCommonRuns: true });
        post(`/api/abnormality/manifests/common-runs`, {
            manifestIds: this.props.selectedManifestIds,
        }).then(
            response =>
                this.setState({
                    commonRuns: response.runs,
                    fetchingCommonRuns: false,
                }),
            error => {
                this.setState({ fetchingCommonRuns: false });
                handleApiError(error, this.props.dispatch);
            }
        );
    };

    getToRuns = runId => {
        const url = this.props.isPullForward
            ? '/api/recovery-actions/pull/to-runs'
            : '/api/recovery-actions/slide/to-runs';

        this.setState({ fetchingToRuns: true });
        post(url, {
            manifestIds: this.props.selectedManifestIds,
            runId: runId,
        }).then(
            response =>
                this.setState({
                    toRuns: response.runs,
                    fetchingToRuns: false,
                }),
            error => {
                this.setState({ fetchingToRuns: false });
                handleApiError(error, this.props.dispatch);
            }
        );
    };

    getToRunStops = runId => {
        this.setState({ fetchingToRunStops: true });
        get(`/api/runs/${runId}/stops`).then(
            response =>
                this.setState({
                    toRunStops: response.stops,
                    fetchingToRunStops: false,
                }),
            error => {
                this.setState({ fetchingToRunStops: false });
                handleApiError(error, this.props.dispatch);
            }
        );
    };

    formatRunTitle = (runs, id) => {
        if (runs.length) {
            const run = find(runs, ['runId', id]);
            return run ? formatRun(run) : 'Select a run';
        }
        return 'No runs available...';
    };

    formatStopTitle = (stops, id) => {
        if (stops.length) {
            const stop = find(stops, ['stopId', id]);
            return stop ? formatStopLocation(stop) : 'Select a stop';
        }
        return 'No stops available...';
    };

    handleFromRunChange = runId => {
        this.handleRunChange('fromRunId', runId);
        this.getToRuns(runId);
    };

    handleToRunChange = runId => {
        this.handleRunChange('toRunId', runId);
        this.getToRunStops(runId);
    };

    handleRunChange = (fieldName, runId) => {
        // Clear error message
        this.props.clearErrorMessage();
        // Clear validation errors
        if (this.state.errors.runs) {
            let errors = this.state.errors;
            delete errors.runs;
            this.setState({ errors: errors });
        }
        // Set new value
        this.setState({
            [fieldName]: runId,
        });
    };

    handleStopChange = fieldName => stopId => {
        // Clear error message
        this.props.clearErrorMessage();
        // Clear validation errors
        if (this.state.errors[fieldName]) {
            let errors = this.state.errors;
            delete errors[fieldName];
            this.setState({ errors });
        }
        // Set new value
        this.setState({
            [fieldName]: stopId,
        });
    };

    handleDateChange = name => momentDate => {
        let errors = this.state.errors;
        delete errors[name];
        if (!moment(momentDate).isValid()) {
            errors[name] = 'Please insert a valid date with format: DD-MM-YYYY HH:mm';
        }
        this.setState({ errors: errors, [name]: momentDate });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleTapChecked = () => {
        this.setState({ tapChecked: !this.state.tapChecked });
    };

    handleConfirm = () => {
        const {
            comment,
            tapChecked,
            tapDate,
            tapDueDate,
            tapNumber,
            fromRunId,
            toRunId,
            newLoadStopId,
            newUnloadStopId,
            dueDate,
        } = this.state;
        const selectedManifests = [];
        const errors = validateFields({
            selectedRun: fromRunId,
            selectedManifests,
            tapDate,
            tapDueDate,
            dueDate,
        });
        this.setState({ errors });

        if (!errors.runs) {
            let tempManList = [];
            forEach(this.props.selectedAbnManifestIds, selManId =>
                forEach(this.props.manifestGroups, group =>
                    forEach(group.manifests, manifest => {
                        if (selManId === manifest.abnormalityManifestId) {
                            //selectedManifests consist of abnormalityManifestIds
                            tempManList.push({
                                manifestId: manifest.manifest.manifestId,
                                abnormalityManifestId: manifest.abnormalityManifestId,
                            });
                        }
                    })
                )
            );

            const formData = {
                abnormalityId: this.props.abnormalityAnalysis.abnormalityId,
                abnormalityManifests: tempManList,
                comment,
                dueDate: dueDate.toISOString(),
                fromRunId,
                newLoadStopId,
                newUnloadStopId,
                toRunId,
            };

            if (tapChecked) {
                formData.tapDate = tapDate.toISOString();
                formData.tapDueDate = tapDueDate.toISOString();
                formData.tapNumber = tapNumber;
            }

            this.props.isPullForward
                ? this.props.createPullForwardRecoveryAction(formData)
                : this.props.createSlideRecoveryAction(formData);
        }
    };

    render() {
        const {
            showModal,
            onClose,
            onHide,
            backdrop,
            isPending,
            isPullForward = false,
        } = this.props;
        const {
            comment,
            commonRuns,
            dueDate,
            fetchingCommonRuns,
            fetchingToRunStops,
            fetchingToRuns,
            fromRunId,
            newLoadStopId,
            tapChecked,
            tapDate,
            tapDueDate,
            tapNumber,
            toRunId,
            toRuns,
            toRunStops,
            newUnloadStopId,
            errors,
        } = this.state;

        return (
            <Modal show={showModal} backdrop={backdrop} onHide={onHide}>
                <Modal.Header>
                    <Modal.Title>{isPullForward ? 'Pull forward' : 'Slide'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isPending ? (
                        <div className="text-center">
                            <SmallLoader />
                        </div>
                    ) : (
                        <div>
                            <Row style={{ marginBottom: 20 }}>
                                <Col sm={5} style={{ marginTop: 5 }}>
                                    Run you want to {isPullForward ? 'pull' : 'slide'} from *
                                </Col>
                                <Col sm={7}>
                                    {fetchingCommonRuns && <SmallLoader tiny />}
                                    {!fetchingCommonRuns && (
                                        <DropdownButton
                                            id="commonRuns"
                                            style={
                                                errors.runs && {
                                                    borderColor: '#CF142B',
                                                }
                                            }
                                            title={this.formatRunTitle(commonRuns, fromRunId)}
                                            onSelect={this.handleFromRunChange}
                                        >
                                            {map(commonRuns, run => {
                                                return (
                                                    <MenuItem
                                                        key={run.runId}
                                                        eventKey={run.runId}
                                                        active={fromRunId === run.runId}
                                                    >
                                                        {formatRun(run)}
                                                    </MenuItem>
                                                );
                                            })}
                                        </DropdownButton>
                                    )}
                                    {errors &&
                                        errors.runs && (
                                            <p
                                                style={{
                                                    color: '#CF142B',
                                                    marginTop: 5,
                                                }}
                                            >
                                                {errors.runs}
                                            </p>
                                        )}
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: 20 }}>
                                <Col sm={5} style={{ marginTop: 10 }}>
                                    Run you want to {isPullForward ? 'pull' : 'slide'} to *
                                </Col>
                                <Col sm={7} style={{ marginTop: 5 }}>
                                    {fetchingToRuns && <SmallLoader tiny />}
                                    {!fetchingToRuns && (
                                        <DropdownButton
                                            id="toRuns"
                                            style={
                                                errors.toRun && {
                                                    borderColor: '#CF142B',
                                                }
                                            }
                                            title={this.formatRunTitle(toRuns, toRunId)}
                                            onSelect={this.handleToRunChange}
                                            disabled={!toRuns.length}
                                        >
                                            {map(toRuns, run => {
                                                return (
                                                    <MenuItem
                                                        key={run.runId}
                                                        eventKey={run.runId}
                                                        active={toRunId === run.runId}
                                                    >
                                                        {formatRun(run)}
                                                    </MenuItem>
                                                );
                                            })}
                                        </DropdownButton>
                                    )}
                                    {errors &&
                                        errors.toRun && (
                                            <p
                                                style={{
                                                    color: '#CF142B',
                                                    marginTop: 5,
                                                }}
                                            >
                                                {errors.toRun}
                                            </p>
                                        )}
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: 20 }}>
                                <Col sm={5} style={{ marginTop: 10 }}>
                                    Load stop *
                                </Col>
                                <Col sm={7} style={{ marginTop: 5 }}>
                                    {fetchingToRunStops && <SmallLoader tiny />}
                                    {!fetchingToRunStops && (
                                        <DropdownButton
                                            id="loadStop"
                                            style={
                                                errors.loadStop && {
                                                    borderColor: '#CF142B',
                                                }
                                            }
                                            title={this.formatStopTitle(toRunStops, newLoadStopId)}
                                            onSelect={this.handleStopChange('newLoadStopId')}
                                            disabled={!toRunStops.length}
                                        >
                                            {map(toRunStops, stop => {
                                                return (
                                                    <MenuItem
                                                        key={stop.stopId}
                                                        eventKey={stop.stopId}
                                                        active={newLoadStopId === stop.stopId}
                                                    >
                                                        {formatStopLocation(stop)}
                                                    </MenuItem>
                                                );
                                            })}
                                        </DropdownButton>
                                    )}
                                    {errors &&
                                        errors.loadStop && (
                                            <p
                                                style={{
                                                    color: '#CF142B',
                                                    marginTop: 5,
                                                }}
                                            >
                                                {errors.loadStop}
                                            </p>
                                        )}
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: 20 }}>
                                <Col sm={5} style={{ marginTop: 10 }}>
                                    Unload stop *
                                </Col>
                                <Col sm={7} style={{ marginTop: 5 }}>
                                    {fetchingToRunStops && <SmallLoader tiny />}
                                    {!fetchingToRunStops && (
                                        <DropdownButton
                                            id="unloadStop"
                                            style={
                                                errors.unloadStop && {
                                                    borderColor: '#CF142B',
                                                }
                                            }
                                            title={this.formatStopTitle(
                                                toRunStops,
                                                newUnloadStopId
                                            )}
                                            onSelect={this.handleStopChange('newUnloadStopId')}
                                            disabled={!toRunStops.length}
                                        >
                                            {map(toRunStops, stop => {
                                                return (
                                                    <MenuItem
                                                        key={stop.stopId}
                                                        eventKey={stop.stopId}
                                                        active={newUnloadStopId === stop.stopId}
                                                    >
                                                        {formatStopLocation(stop)}
                                                    </MenuItem>
                                                );
                                            })}
                                        </DropdownButton>
                                    )}
                                    {errors &&
                                        errors.unloadStop && (
                                            <p
                                                style={{
                                                    color: '#CF142B',
                                                    marginTop: 5,
                                                }}
                                            >
                                                {errors.unloadStop}
                                            </p>
                                        )}
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: 20 }}>
                                <Col sm={5} style={{ marginTop: 10 }}>
                                    <p>Due date *</p>
                                </Col>
                                <Col sm={6}>
                                    <Datetime
                                        value={dueDate}
                                        onChange={this.handleDateChange('dueDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat="HH:mm"
                                        inputProps={{ maxLength: 255 }}
                                        className={errors.dueDate && 'datetime-error'}
                                    />
                                    {errors &&
                                        errors.dueDate && (
                                            <p
                                                style={{
                                                    color: '#CF142B',
                                                    marginTop: 5,
                                                }}
                                            >
                                                {errors.dueDate}
                                            </p>
                                        )}
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={5}>
                                    <Checkbox checked={tapChecked} onChange={this.handleTapChecked}>
                                        With tap
                                    </Checkbox>
                                </Col>
                            </Row>
                            {tapChecked && (
                                <div>
                                    <Row style={{ marginBottom: 20 }}>
                                        <Col sm={5} style={{ marginTop: 10 }}>
                                            Tap date *
                                        </Col>
                                        <Col sm={7} style={{ marginTop: 5 }}>
                                            <Datetime
                                                value={tapDate}
                                                onChange={this.handleDateChange('tapDate')}
                                                dateFormat="DD-MM-YYYY"
                                                timeFormat="HH:mm"
                                                inputProps={{
                                                    maxLength: 255,
                                                }}
                                                className={errors.tapDate && 'datetime-error'}
                                            />
                                            {errors &&
                                                errors.tapDate && (
                                                    <p
                                                        style={{
                                                            color: '#CF142B',
                                                            marginTop: 5,
                                                        }}
                                                    >
                                                        {errors.tapDate}
                                                    </p>
                                                )}
                                        </Col>
                                    </Row>
                                    <Row style={{ marginBottom: 20 }}>
                                        <Col sm={5} style={{ marginTop: 10 }}>
                                            Tap due date *
                                        </Col>
                                        <Col sm={7} style={{ marginTop: 5 }}>
                                            <Datetime
                                                value={tapDueDate}
                                                onChange={this.handleDateChange('tapDueDate')}
                                                dateFormat="DD-MM-YYYY"
                                                timeFormat="HH:mm"
                                                inputProps={{
                                                    maxLength: 255,
                                                }}
                                                className={errors.tapDueDate && 'datetime-error'}
                                            />
                                            {errors &&
                                                errors.tapDueDate && (
                                                    <p
                                                        style={{
                                                            color: '#CF142B',
                                                            marginTop: 5,
                                                        }}
                                                    >
                                                        {errors.tapDueDate}
                                                    </p>
                                                )}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={5} style={{ marginTop: 10 }}>
                                            Tap number
                                        </Col>
                                        <Col sm={7} style={{ marginTop: 5 }}>
                                            <FormControl
                                                name="tapNumber"
                                                value={tapNumber}
                                                onChange={this.handleChange}
                                                maxLength="1000"
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            )}
                            <Row style={{ marginTop: 20 }}>
                                <div style={{ margin: 15 }}>
                                    <Comments
                                        comment={comment}
                                        onCommentChange={this.handleChange}
                                    />
                                </div>
                            </Row>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="success"
                        onClick={isPending ? null : this.handleConfirm}
                        disabled={!!errors.dueDate || isPending}
                    >
                        Create
                    </Button>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="default"
                        onClick={isPending ? null : onClose}
                        disabled={isPending}
                    >
                        Dismiss
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default connect(
    state => ({
        isPending: getIsPending(state),
        errorMessage: getErrorMessage(state),
        isRejected: getError(state),
    }),
    dispatch =>
        bindActionCreators(
            {
                createSlideRecoveryAction,
                createPullForwardRecoveryAction,
                clearErrorMessage,
            },
            dispatch
        )
)(SlidePullModal);
